import { useEffect, useRef, useState } from "react";
import ControlBoardContainer from "../components/controlBoard/ControlBoardContainer";
import PreviewContainer from "../components/controlBoard/PreviewContainer";
import EditorContainer from "../components/editor/EditorContainer";
import MenuBar from "../components/MenuBar";
import TopNavBar from "../components/TopNavBar";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import PageNotAccessable from "./PageNotAccessable";
import { activateFullScreenPrompt } from "../redux/fullScreenPromptSlice";
import { getCustomerReports, getCustomers, getDbReports } from "../service/apiAccessLogic";
import { msalInstance } from "../index"
import { setAllCustomersID, setInvalidCustomerReports, setInvalidReports, setLastSyncTime, setValidCustomerReports } from "../redux/dataSlice";
import { getSyncTimeString } from "../service/menuLogic";
import Theme from "../Theme";
import ReportBackground from '../resource/DEFEND-Main-Contact.jpg'
import EditingToolbar from "../components/editor/EditingToolbar";
import { getFromPath } from "../service/dataLogic";
import { ReportObject } from "../models/ReportModel";

function EditingPage() {
	const userMode = useAppSelector((state) => state.user.userMode)
	const previewMode = useAppSelector((state) => state.data.preview)
	const previewRef = useRef<HTMLDivElement | null>(null)
	const invalidReports = useAppSelector(state => state.data.invalidReports)
	const invalidCustomerReports = useAppSelector(state => state.data.invalidCustomerReports)
	const allCustomersID = useAppSelector((state) => state.data.allCustomersID)
	const currentCustomerId = useAppSelector((state) => state.data.currentCustomerId)
	const dispatch = useAppDispatch()

	const [pageSelected, setPageSelected] = useState(1);

	let currentReport = useAppSelector((state) => state.data.currentReport);  
	const metadata = currentReport == null ? null : getFromPath(currentReport, "content.metadata") as ReportObject;
	const report_id = currentReport == null ? "" : getFromPath(currentReport, "report_id") as string;
	const multipageEnabled = !metadata ? false : metadata["multipage"] as boolean;

	const isImhrMonthly = report_id.includes("ice_imhr_month");

	useEffect(() => {
		if (currentCustomerId === "") return		
		const hasInvalidReports = invalidCustomerReports[currentCustomerId] && Object.keys(invalidCustomerReports[currentCustomerId]).length > 0;
		if (hasInvalidReports) {
			dispatch(activateFullScreenPrompt("false"));
		}
	}, [invalidCustomerReports])

	if (userMode === "editor") {
		return (
			<div className={`flex ${Theme.Colors.DarkWebBg}`} onLoad={async () => {
				if (allCustomersID.length == 0) {
					dispatch(activateFullScreenPrompt("loading"))
					getCustomers(msalInstance)
						.then((response) => {
							dispatch(activateFullScreenPrompt("false"));  
							dispatch(setAllCustomersID(response.data));		

							const customerIds = response.data.map((customer: any) => customer.id);

                            for (const customerId of customerIds) {
								getCustomerReports(msalInstance, false, customerId).then((response) => {
									dispatch(setInvalidCustomerReports({ customerId: customerId, reports: response.data }));
								}).catch(() => {
									console.log("Error loading reports for customer: " + customerId);
								});
							}
							for (const customerId of customerIds) {
								getCustomerReports(msalInstance, true, customerId).then((response) => {
									dispatch(setValidCustomerReports({ customerId: customerId, reports: response.data }));
								}).catch(() => {
									console.log("Error loading reports for customer: " + customerId);
								});
							}
						})
						.catch(() => {
							console.log("Error loading all customers ID");
						});
				}

				dispatch(setLastSyncTime({ time: getSyncTimeString(), type: "editor" }))
			}}>
				<MenuBar onPage="reportEditor" hideDisabled={true} />
				<div className={`w-full flex flex-col items-center min-h-screen pl-44 bg-cover`} style={{ backgroundImage: `url(${ReportBackground})` }} >
					<TopNavBar />
					{isImhrMonthly && <EditingToolbar pageSelected={pageSelected} setPageSelected={setPageSelected}/>}
					<div ref={previewRef} />
					<PreviewContainer page={multipageEnabled ? pageSelected - 1 : -1} showHeader={true}/>
					<ControlBoardContainer />
					<EditorContainer />
				</div>
			</div>
		)
	} else {
		return <PageNotAccessable />
	}

}

export default EditingPage;